import Accordion from '@/common/components/Accordion'
import { useMaintenanceEquipmentPiece } from '@/features/maintenance/features/workflows/features/diagnosticEntry/hooks/equipments/useMaintenanceEquipmentPiece'
import MaintenancePieceAdditionalInformationTable from '@/features/maintenance/features/workflows/features/diagnosticEntry/screens/Update/components/MaintenancePieceAdditionalInformationTable'
import { useMaintenanceWorkflow } from '@/features/maintenance/features/workflows/hooks/useMaintenanceWorkflow'
import { useState } from 'react'

interface MaintenancePieceAdditionalInformationAccordionProps {
  workflowId: string | undefined
  pieceId: string | undefined
}

const MaintenancePieceAdditionalInformationAccordion = ({
  workflowId,
  pieceId,
}: MaintenancePieceAdditionalInformationAccordionProps) => {
  const [isOpen, setIsOpen] = useState(false)

  const { data: maintenanceWorkflow } = useMaintenanceWorkflow(workflowId)

  const { data: maintenancePiece, isPending } = useMaintenanceEquipmentPiece({
    equipmentId: maintenanceWorkflow?.equipment?.id,
    pieceId,
    options: {
      enabled: isOpen && !!maintenanceWorkflow?.equipment?.id && !!pieceId,
    },
  })

  return (
    <Accordion
      head="Informações adicionais"
      className="py-0"
      onToggle={setIsOpen}
      body={
        <MaintenancePieceAdditionalInformationTable
          additionalInformation={maintenancePiece?.additional_information || []}
          isLoading={isOpen && isPending}
        />
      }
    />
  )
}

export default MaintenancePieceAdditionalInformationAccordion
